/* ATLAS — icône panier : le « choc » au moment d'un ajout.
   Après chaque ajout, Dawn remplace le contenu de #cart-icon-bubble par la version
   rendue par le serveur (sections/cart-icon-bubble.liquid), qui porte déjà
   .atl-cart--active quand le panier n'est pas vide. Ici on compare seulement le
   nombre d'articles avant et après, et on pose .is-added sur la nouvelle icône et
   la nouvelle pastille quand il a augmenté. */
(function () {
  'use strict';

  var link = document.getElementById('cart-icon-bubble');
  if (!link || !('MutationObserver' in window)) return;

  function itemCount() {
    var bubble = link.querySelector('.cart-count-bubble');
    if (!bubble) return 0;
    var visible = bubble.querySelector('[aria-hidden="true"]');
    // Au-delà de 99 articles, Dawn n'affiche plus le chiffre
    return visible ? parseInt(visible.textContent, 10) || 0 : 100;
  }

  var last = itemCount();
  new MutationObserver(function () {
    var now = itemCount();
    if (now > last) {
      var icon = link.querySelector('.atl-cart');
      var bubble = link.querySelector('.cart-count-bubble');
      if (icon) icon.classList.add('is-added');
      if (bubble) bubble.classList.add('is-added');
    }
    last = now;
  }).observe(link, { childList: true });
})();
